/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-duration[_ngcontent-%COMP%]   .ea-end-date-duration[_ngcontent-%COMP%]{min-width:108px}.ea-duration[_ngcontent-%COMP%]   .ea-end-date-tooltip[_ngcontent-%COMP%]{bottom:100%}.ea-end-date[_ngcontent-%COMP%]{position:relative}.ea-end-date[_ngcontent-%COMP%]   .ea-end-date-tooltip[_ngcontent-%COMP%]{min-width:260px;bottom:100%;left:50%;transform:translateX(-50%)}"];
export { styles as styles };
